// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"57b1582a","585":"fe2d0ebb"}[chunkId] + ".chunk.js";
};